import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessageWrappedInSpan } from '../../misc';

import {
  ORIGINAL,
  SINGLE_PHOTO,
  FOTO_FLAT,
  VIDEO,
  CERTIFICATE,
  CERTIFICATE_FACE,
  CERTIFICATE_SELECTED_PHOTO,
  SOCIAL_MEDIA,
  VOUCHER,
  ALL_PHOTOS,
  RESTART_PRODUCTION,
} from '../../../utils/variables';

import PhotoIcon from '@material-ui/icons/Photo';
import PhotoLibraryRoundedIcon from '@material-ui/icons/PhotoLibraryRounded';
import TheatersRoundedIcon from '@material-ui/icons/TheatersRounded';
import CardGiftcardRoundedIcon from '@material-ui/icons/CardGiftcardRounded';
import CardMembershipRoundedIcon from '@material-ui/icons/CardMembershipRounded';
import StarsRoundedIcon from '@material-ui/icons/StarsRounded';
import MobileFriendlyRoundedIcon from '@material-ui/icons/MobileFriendlyRounded';

import AccountDownloadTileZipDownload from './AccountDownloadTileZipDownload';
import AccountDownloadTileVideo from './AccountDownloadTileVideo';
import AccountDownloadTileVoucher from './AccountDownloadTileVoucher';
import AccountDownloadDialogTile from './AccountDownloadDialogTile';
import PermMediaRoundedIcon from '@material-ui/icons/PermMediaRounded';
import AccountDownloadTileButton from './AccountDownloadTileButton';
import SyncRoundedIcon from '@material-ui/icons/SyncRounded';

const AccountDownloadTile = ({
  type,
  notActive,
  restartState,
  onScrollToMedia,
  onRequestHighResolutionPhoto,
  values,
  eventSgId,
  isFaceSearchEvent,
  intl,
  isError,
  isPending,
  hasOptions,
  hasOpenedOptions,
  onCertificateDownloadClick,
  onCloseOptions,
  children,
  onOpenCertificateDialog
}) => {
  switch (type) {
    case SINGLE_PHOTO:
      return (
        <AccountDownloadDialogTile
          icon={<PhotoIcon className="account-tile-icon" />}
          textInSpan={
            <FormattedMessageWrappedInSpan
              id="messages.singlePhoto"
              defaultMessage="Single Photo"
            />
          }
          type={type}
          onScrollToMedia={onScrollToMedia}
        />
      );
    case ORIGINAL:
      return (
        <AccountDownloadTileButton
          icon={<StarsRoundedIcon className="account-tile-icon" />}
          textInSpan={
            <FormattedMessageWrappedInSpan
              id="messages.highRes"
              defaultMessage="High Resolution"
            />
          }
          type={type}
          notActive={notActive}
        />
      );

    case RESTART_PRODUCTION:
      return (
        <AccountDownloadTileButton
          icon={<SyncRoundedIcon className="account-tile-icon" />}
          textInSpan={
            notActive ? (
              <FormattedMessageWrappedInSpan
                id="accountDownloadTile.actions.restartProductionSuccess"
                defaultMessage="Request sent"
              />
            ) : (
              <FormattedMessageWrappedInSpan
                id="accountDownloadTile.actions.restartProductionRequest"
                defaultMessage="Request High Resolution"
              />
            )
          }
          notActive={notActive}
          type={type}
          isPending={isPending}
          isError={isError}
          onClick={onRequestHighResolutionPhoto}
          hideQuestionMarkIcon={true}
        />
      );
    case SOCIAL_MEDIA:
      return (
        <AccountDownloadTileButton
          icon={<MobileFriendlyRoundedIcon className="account-tile-icon" />}
          textInSpan={
            <FormattedMessageWrappedInSpan
              id="messages.socialMediaRes"
              defaultMessage="Social Media Resolution"
            />
          }
          type={type}
        />
      );
    case FOTO_FLAT:
      return (
        <AccountDownloadTileZipDownload
          icon={<PhotoLibraryRoundedIcon className="account-tile-icon" />}
          textInSpan={
            <FormattedMessageWrappedInSpan
              id="messages.fotoFlat"
              defaultMessage="Foto-Flat"
            />
          }
          type={type}
          eventSgId={eventSgId}
          values={values?.filter(
            (element) => element != ORIGINAL && element != SOCIAL_MEDIA
          )}
          isFaceSearchEvent={isFaceSearchEvent}
        />
      );
    case VIDEO:
      return (
        <AccountDownloadTileVideo
          icon={<TheatersRoundedIcon className="account-tile-icon" />}
          textInSpan={
            <FormattedMessageWrappedInSpan
              id="accountEventPage.products.video"
              defaultMessage="Video"
            />
          }
          notActive={notActive}
          type={type}
          values={values}
          eventSgId={eventSgId}
          isFaceSearchEvent={isFaceSearchEvent}
          intl={intl}
        />
      );
    case CERTIFICATE:
      return (
        <AccountDownloadDialogTile
          icon={<CardMembershipRoundedIcon className="account-tile-icon" />}
          textInSpan={
            <FormattedMessageWrappedInSpan
              id="accountEventPage.products.certificate"
              defaultMessage="Certificate"
            />
          }
          type={type}
          onScrollToMedia={onScrollToMedia}
          notActive={notActive}
        />
      );
    case CERTIFICATE_SELECTED_PHOTO:
      return (
        <AccountDownloadTileButton
          icon={<CardMembershipRoundedIcon className="account-tile-icon" />}
          textInSpan={
            <FormattedMessageWrappedInSpan
              id="accountEventPage.products.certificate"
              defaultMessage="Certificate"
            />
          }
          type={type}
          isPending={isPending}
          hasOptions={hasOptions}
          onClick={onCertificateDownloadClick}
          hasOpenedOptions={hasOpenedOptions}
          onCloseOptions={onCloseOptions}
          error={isError}
        >
          {children}
        </AccountDownloadTileButton>
      );
    case CERTIFICATE_FACE:
      return (
        <AccountDownloadTileButton
          icon={<CardMembershipRoundedIcon className="account-tile-icon" />}
          textInSpan={
            <FormattedMessageWrappedInSpan
              id="accountEventPage.products.certificate"
              defaultMessage="Certificate"
            />
          }
          type={type}
          onClick={onOpenCertificateDialog}
        />
      );
    case ALL_PHOTOS:
      return (
        <AccountDownloadTileZipDownload
          icon={<PermMediaRoundedIcon className="account-tile-icon" />}
          textInSpan={
            <FormattedMessageWrappedInSpan
              id="accountEventPage.products.allPhotos"
              defaultMessage="All photos"
            />
          }
          restartState={restartState}
          eventSgId={eventSgId}
          type={type}
          values={values?.filter(
            (element) => element === ORIGINAL || element === SOCIAL_MEDIA
          )}
        />
      );
    case VOUCHER:
      return (
        <AccountDownloadTileVoucher
          icon={<CardGiftcardRoundedIcon className="account-tile-icon" />}
          textInSpan={
            <FormattedMessageWrappedInSpan
              id="accountEventPage.products.voucher"
              defaultMessage="Voucher"
            />
          }
          values={values}
        />
      );
  }
};

AccountDownloadTile.propTypes = {
  type: PropTypes.string,
  values: PropTypes.array,
  notActive: PropTypes.bool,
  restartState: PropTypes.string,
  onScrollToMedia: PropTypes.func,
  eventSgId: PropTypes.number,
  isFaceSearchEvent: PropTypes.bool,
  intl: PropTypes.object,
  onRequestHighResolutionPhoto: PropTypes.func,
  isError: PropTypes.bool,
  isPending: PropTypes.bool,
  hasOptions: PropTypes.bool,
  hasOpenedOptions: PropTypes.bool,
  onCertificateDownloadClick: PropTypes.func,
  onCloseOptions: PropTypes.func,
  children: PropTypes.node,
  onOpenCertificateDialog: PropTypes.func,
};

export default AccountDownloadTile;
